import { SpherePlatformApp } from '@sphere/platform';
import { criticalListsApp } from './critical-lists';
import { PATHS } from './critical-lists.paths';

export const CriticalListsApp: SpherePlatformApp = {
    APP: criticalListsApp,
    PATHS
};
